module.exports = __webpack_public_path__ + "img/thumbnail_MuteSwan_j_normal.83eacf73.png";